import React, { useState, useEffect, useContext } from 'react';
import {TextStyle, Layout, Card, Stack, Link, Button, Icon, InlineError} from '@shopify/polaris';
import {ViewMinor} from '@shopify/polaris-icons';
import {useReducerRequest} from '@thinkwell/react.common';
import ReactHtmlParser from 'react-html-parser'
import EditProduct from './EditProduct';
import EditCourse from '../courses/EditCourse';
import { ProductContext } from '../contexts/Product'
import { CoursesProvider } from '../contexts/Courses'
import compact from 'lodash/compact'
import omit from 'lodash/omit'

const formatDate = (dateStr) => {
  return new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit'
  }).format(new Date(dateStr))
};

export default function Product(props) {
  const [product, setProduct] = useContext(ProductContext);
  const [editing, setEditing] = useState(false)

  const [stateDelete, onDelete] = useReducerRequest('delete', {onSuccess: () => {
    props.onDelete && props.onDelete()
  }})

  const deleteProduct = () => {
    onDelete(`/products/${product.id}.json`,
      null,
      'Are you sure you want to delete this product? This action is irreversible.'
    )
  }

  const onCourseSave = (courseSaved) => {
    const courses = [].concat(product.courses)
    const index = courses.findIndex((course) => course.id == courseSaved.id)
    if (index == -1) {
      courses.push(courseSaved)
    } else {
      courses.splice(index, 1, courseSaved)
    }
    setProduct(Object.assign({}, product, {courses: courses}))
  }

  return (
    <div className="product">
      <Layout>
        <Layout.Section primary>
        { !editing ?
          <Card>
            <Card.Header title={product.name}>
              <Button plain onClick={() => props.navigateToRef.current('products', {withContext: 'url'}) }>Back to Products</Button>
              <Button plain onClick={() => setEditing(true) }>Edit</Button>
              <Button plain destructive loading={stateDelete.requesting} onClick={deleteProduct}>Delete</Button>
              {stateDelete.error ? <InlineError message={stateDelete.error} fieldID="deleteUserErrorFieldID" /> : null}
            </Card.Header>
            <Card.Section>
              <table className="table-item"><tbody>
                { product.default_course ? <tr><th>Default Course</th><td>{product.default_course.name}</td></tr> : null }
                <tr><th>Updated at</th><td>{formatDate(product.updated_at)}</td></tr>
              </tbody></table>
            </Card.Section>
            { product.courses && product.courses.length ?
              <Card.Section title="Courses">
                <table className="table-item"><tbody>
                <tr><th>Name</th><th>View Tree</th></tr>
                {
                  (product.courses || []).map((course) => {
                    course.product = omit(product, ['courses'])
                    return <tr key={course.id}>
                      <td><EditCourse item={course} onSave={onCourseSave} useModal/></td>
                      <td className="view-tree"><Button plain icon={<Icon source={ViewMinor} />} onClick={() => window.open(`/courses/${course.id}/tree`, '_blank')} /></td>
                    </tr>
                  })
                }
                </tbody></table>
              </Card.Section>
            : null }
          </Card> : null
        }
        { editing ?
          <EditProduct
            active={editing}
            item={product}
            onSave={setProduct}
            onActive={(active) => { if (active != editing) { setEditing(active) } }}
          /> : null
        }
        </Layout.Section>
      </Layout>
    </div>
  );
}
